<div class="c-error-page">
  <div class="c-error-page__heading p-grid u-margin-bottom--xxl">
    <h1 class="p-col-12">{{ titleInfo.title | translate }}</h1>
    <h2 class="p-col-12">{{ titleInfo.subTitle | translate }}</h2>
  </div>

  <div class="c-error-page__img-container p-grid u-margin-bottom--xxl p-col-12 p-justify-center">
    <img
      class="p-col c-error-page__img"
      ngSrc="assets/images/flag.svg"
      alt=""
      width="181"
      height="224"
      priority
    />
  </div>

  <div class="c-error-page__btn p-grid u-margin-bottom--xxl p-col-12 p-justify-center">
    <bo-button text="MTR_COMMON_BACK" (click)="navigateBack()" />
  </div>
</div>
